import { Controller } from "@hotwired/stimulus"

// Live-updates a FAQ row's badge as the merchant edits the answer in the modal: a filled answer is
// "Instant" (green, free); a blank answer is "AI agent" (grey). Mirrors editable_label's live-label
// approach so the row reflects edits before the form is submitted.
export default class extends Controller {
  static targets = ["badge"]

  update(event) {
    const hasAnswer = event.target.value.trim().length > 0
    const badge = this.badgeTarget

    badge.textContent = hasAnswer ? "Instant" : "AI agent"
    badge.title = hasAnswer ? "Answered instantly — free" : "Opens a conversation with the AI agent"
    badge.classList.toggle("bg-green-100", hasAnswer)
    badge.classList.toggle("text-green-700", hasAnswer)
    badge.classList.toggle("bg-gray-100", !hasAnswer)
    badge.classList.toggle("text-gray-500", !hasAnswer)
  }
}
